import { Skeleton } from '@/components/ui';

export function ReportCommentSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-amber-200/70 bg-gradient-to-b from-amber-50/95 to-amber-100/40 shadow-sm dark:border-amber-900/35 dark:from-amber-950/25 dark:to-amber-950/10">
      <div className="flex items-center justify-between gap-2 border-b border-amber-200/50 bg-amber-50/60 px-4 py-2 dark:border-amber-900/30 dark:bg-amber-950/20">
        <Skeleton className="h-5 w-20 bg-amber-200/80 dark:bg-amber-900/40" />
        <Skeleton className="h-8 w-24 rounded-md bg-amber-200/80 dark:bg-amber-900/40" />
      </div>
      <div className="px-4 py-4 sm:px-5 sm:py-5">
        <div className="mx-auto max-w-2xl rounded-md border border-amber-200/60 bg-gradient-to-br from-[#fdfbf7] to-[#f8f2e8] px-4 py-4 dark:border-amber-800/40 dark:from-amber-950/40 dark:to-stone-950">
          <Skeleton className="mb-3 h-3.5 w-44 bg-amber-200/70 dark:bg-amber-900/50" />
          <div className="space-y-2">
            <Skeleton className="h-3.5 w-full bg-amber-200/60 dark:bg-amber-900/40" />
            <Skeleton className="h-3.5 w-full bg-amber-200/60 dark:bg-amber-900/40" />
            <Skeleton className="h-3.5 w-4/5 bg-amber-200/60 dark:bg-amber-900/40" />
            <Skeleton className="h-3.5 w-full bg-amber-200/60 dark:bg-amber-900/40" />
            <Skeleton className="h-3.5 w-2/3 bg-amber-200/60 dark:bg-amber-900/40" />
          </div>
          <Skeleton className="mt-4 h-4 w-16 bg-amber-200/70 dark:bg-amber-900/50" />
        </div>
      </div>
      <div className="flex justify-center gap-1.5 pb-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-amber-300/90 dark:bg-amber-800/60"
          />
        ))}
      </div>
    </div>
  );
}
